/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import { transformRequestOptions } from "utils/queryString";
import api from "_config/api";

interface ObterSexoResponse {
  value: number;
  name: string;
}

interface State {
  isRequesting: boolean;
  successPayload: ObterSexoResponse[];
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: [],
  errors: []
};

const obterSexoAnimalSlice = createSlice({
  name: "zoonose@obterSexoAnimal",
  initialState,
  reducers: {
    obterSexoAnimal: (state): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterSexoAnimalSuccess: (
      state,
      action: PayloadAction<ObterSexoResponse[]>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterSexoAnimalFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction() {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/saude/listar-sexo`
    );

    const { data } = response;

    yield put(obterSexoAnimalSuccess(data));
  } catch (error) {
    yield put(obterSexoAnimalFailed(formatError(error)));
  }
}

export const {
  obterSexoAnimal,
  obterSexoAnimalSuccess,
  obterSexoAnimalFailed
} = obterSexoAnimalSlice.actions;

export const { reducer } = obterSexoAnimalSlice;

export const saga = takeLatest(obterSexoAnimal.type, sagaFunction);
